module.exports = __webpack_public_path__ + "static/media/free.bccb8de4.jpg";